module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/216.6355746f.png";